module.exports = __webpack_public_path__ + "img/img-7.60a440c5.webp";